window.themeObj = {
  init: () => {
    window.themeObj.templates.init();
  }
};

window.themeObj.tools = {
  toCapitalize: (string) => {
    const words = string.split(' ');

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }

    return words.join(' ');
  }
};

window.themeObj.templates = {
  init: () => {
    window.themeObj.templates.collection.init();
  }
};

window.themeObj.templates.collection = {
  init: () => {
    
    if (document.body.classList.contains('template-collection')) {

      if (document.querySelector('.collection-template-cms__data')) {
        new window.themeObj.templates.collection.cms();
      }
    }
  },
  default: class {
    
    constructor () {
      const obj = this;
    }
  },
  cms: class {
  
    constructor () {
      const obj = this;
      
      obj.data = {
        shop: window.Shopify.shop,
        productsLimit: 16,
        productIds: [],
        query: decodeURIComponent(document.querySelector('.collection-template-cms__data').getAttribute('data-cms-query')),
        productUrl: document.querySelector('.collection-template-cms__data').getAttribute('data-product-url'),
        getHeaders: () => {
          return {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Shopify-Storefront-Access-Token': window.platmartSwatchesConfig.storefrontToken
          };
        }
      };

      obj.data.clearUrl = obj.data.query.replace(/^(.+)\?.+$/, '$1');
      
      obj.render();
    }

    render() {
      const obj = this;
      
      let url;
      
      if (/\/collections\/.+/.test(obj.data.query)) {
        url = 'https://services.mybcapps.com/bc-sf-filter/filter';
        url += `?shop=${obj.data.shop}&page=1&limit=${obj.data.productsLimit}&sort=manual&display=grid&currency=${window.Shopify.currency.active.toLowerCase()}&currency_rate=${window.Shopify.currency.rate}&country=${window.Shopify.country.toLowerCase()}&product_available=true&variant_available=true&build_filter_tree=true&check_cache=false&locale=${window.Shopify.locale}`;
        const originalCollectionId = document.querySelector('.collection-template-cms__data').getAttribute('data-original-collection-id');
        
        if (originalCollectionId) {
          url += `&collection_scope=${originalCollectionId}`;
        }
  
      } else {
        url = 'https://services.mybcapps.com/bc-sf-filter/search';
        url += `?shop=${obj.data.shop}&page=1&limit=${obj.data.productsLimit}&sort=relevance&display=grid&currency=${window.Shopify.currency.active.toLowerCase()}&currency_rate=${window.Shopify.currency.rate}&country=${window.Shopify.country.toLowerCase()}&collection_scope=0&product_available=true&variant_available=true&build_filter_tree=true&check_cache=false&locale=${window.Shopify.locale}`;
  
        const cmsUrlParameters = new URLSearchParams(obj.data.query);

        const clearAllLink = document.querySelector('.boost-pfs-filter-refine-by .boost-pfs-filter-option-title .boost-pfs-filter-clear-all');
  
        if (clearAllLink) {
          clearAllLink.style.display = 'none';
        }
      }
      
      if (obj.data.query.includes('?')) {
        const queryParameters = obj.data.query.split('?')[1].split('&');
  
        for (var i = 0; i < queryParameters.length; i++) {
          const queryParameter = queryParameters[i];
          const queryParameterName = queryParameter.split('=')[0];
          const queryParameterValue = queryParameter.split('=')[1];
          
          url += `&`;

          if (/^pf\_m\_/.test(queryParameterName)) {
            url += `&${encodeURIComponent(queryParameterName + '[]')}`;
            
          } else {
            url += `&${encodeURIComponent(queryParameterName)}`;
          }
          
          url += `=${queryParameterValue}`;
        }
      }

      fetch(url)
      .then((response) => response.json())
      .then(function(response) {
        const showMoreButtonTotal = document.querySelector('.boost-pfs-filter-number-result');
  
        if (showMoreButtonTotal) {
          showMoreButtonTotal.innerHTML = ' (' + response.total_product + ')';
        }

        obj.renderSorting();
        obj.renderMobileSorting();
        
        obj.data.products = {
          items: response.products
        };
        
        obj.renderProducts();
        obj.renderMobileProducts();

        obj.data.filters = {
          items: response.filter.options
        };

        obj.renderFilters();
        obj.renderMobileFilters();
        
        obj.data.pagination = {
          total: parseInt(response.total_product / 16) - 1,
          current: 1
        };

        obj.renderPagination();
        
      }).catch((error) => {
        console.log(`Failed to load collection swatches. ${error}`);
      });
    }

    renderPagination() {
      const obj = this;
      
      const wrapper = document.querySelector('.boost-pfs-filter-bottom-pagination');

      if (obj.data.pagination.total > 0) {
        wrapper.innerHTML = '<ul></ul>';

        const itemsWrapper = wrapper.querySelector('ul');
  
        for (var i = 0; i < obj.data.pagination.total; i++) {
          const page = (i + 1);

          if (page == obj.data.pagination.current) {
            itemsWrapper.insertAdjacentHTML(
              'beforeend',
              `<li>
                <span class="boost-pfs-filter-pagination-active" aria-label="Page ${page}">${page}</span>
              </li>`
            );
          
          } else {
            var pageLink = obj.data.query;

            if (pageLink.includes('?')) {
              pageLink += '&';
            
            } else {
              pageLink += '&';
            }
          
            pageLink += `page=${page}`;
          
            itemsWrapper.insertAdjacentHTML(
              'beforeend',
              `<li>
                <a class="page-link-boost" href="${pageLink}" aria-label="Page ${page}" title="Page ${page}">${page}</a>
              </li>`
            );
          }
        }

        if (obj.data.pagination.total > 2) {
          var pageLink = obj.data.query;

          if (pageLink.includes('?')) {
            pageLink += '&';
          
          } else {
            pageLink += '&';
          }
        
          pageLink += 'page=' + (obj.data.pagination.current + 1);
        
          itemsWrapper.insertAdjacentHTML(
            'beforeend',
            `<li>
              <a class="page-link-boost" href="${pageLink}" aria-label="Page Next">→</a>
            </li>`
          );
        }
        
        wrapper.style.display = 'block';

        // Add click event listeners to pagination links
        const paginationLinks = wrapper.querySelectorAll('a.page-link-boost');
        paginationLinks.forEach(link => {
          link.addEventListener('click', (e) => {
            console.log("HELLO");
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            setTimeout(() => {
              window.location.href = link.href;
            }, 300);
          });
        });
      }
    }

    /*** SORTING ***/
    renderSorting() {
      const obj = this;

      const wrapper = document.querySelector('.boost-pfs-filter-right-col .boost-pfs-filter-top-sorting');
      wrapper.innerHTML = 
        `<label>Sort By:</label>
        <button class="boost-pfs-filter-top-sorting-wrapper" aria-label="Default"><span class="sort-by-label" aria-hidden="true"><span aria-hidden="true">Default</span></span></button>
        <ul class="boost-pfs-filter-filter-dropdown" style="display: none;">
          <li aria-label="Featured"><a href="#" data-sort="relevance" class="" title="Featured" aria-label="Featured">Featured</a></li>
          <li aria-label="Best selling"><a href="#" data-sort="best-selling" class="" title="Best selling" aria-label="Best selling">Best selling</a></li>
          <li aria-label="Alphabetically, A-Z"><a href="#" data-sort="title-ascending" class="" title="Alphabetically, A-Z" aria-label="Alphabetically, A-Z">Alphabetically, A-Z</a></li>
          <li aria-label="Alphabetically, Z-A"><a href="#" data-sort="title-descending" class="" title="Alphabetically, Z-A" aria-label="Alphabetically, Z-A">Alphabetically, Z-A</a></li>
          <li aria-label="Price, low to high"><a href="#" data-sort="price-ascending" class="" title="Price, low to high" aria-label="Price, low to high">Price, low to high</a></li>
          <li aria-label="Price, high to low"><a href="#" data-sort="price-descending" class="" title="Price, high to low" aria-label="Price, high to low">Price, high to low</a></li>
          <li aria-label="Date, old to new"><a href="#" data-sort="created-ascending" class="" title="Date, old to new" aria-label="Date, old to new">Date, old to new</a></li>
          <li aria-label="Date, new to old"><a href="#" data-sort="created-descending" class="" title="Date, new to old" aria-label="Date, new to old">Date, new to old</a></li>
        </ul>`;

      const button = wrapper.querySelector('.boost-pfs-filter-top-sorting-wrapper');

      if (button) {
        const itemsWrapper = document.querySelector('.boost-pfs-filter-filter-dropdown');
        const items = document.querySelectorAll('.boost-pfs-filter-filter-dropdown li a');
        
        button.addEventListener('click', () => {

          if (wrapper.classList.contains('boost-pfs-filter-sort-active')) {
            wrapper.classList.remove('boost-pfs-filter-sort-active');
            itemsWrapper.style.display = 'none';
            
          } else {
            wrapper.classList.add('boost-pfs-filter-sort-active');
            itemsWrapper.style.display = 'block';
          }
    
          if (items.length) {
    
            for (var i = 0; i < items.length; i++) {
              const item = items[i];
    
              item.addEventListener('click', () => {
                const itemLink = item.children;
                const itemValue = item.getAttribute('data-sort');
                
                var newItemLink = obj.data.query;
    
                if (newItemLink.includes('?')) {
                  newItemLink += '&'
                }
    
                newItemLink += `sort=${itemValue}`;
                window.location.href = newItemLink;
              });
            }
          }
        });
      }
    }
    
    renderMobileSorting() {
      const obj = this;

      const wrapper = document.querySelector('.boost-pfs-filter-top-sorting-mobile');
      wrapper.innerHTML = 
        `<label>Sort By:</label>
        <button class="boost-pfs-filter-top-sorting-wrapper" aria-label="Default">
          <span class="sort-by-label" aria-hidden="true">
            <span aria-hidden="true">Default</span>
          </span>
        </button>
        <ul class="boost-pfs-filter-filter-dropdown">
          <li aria-label="Featured"><a href="#" data-sort="relevance" title="Featured" aria-label="Featured">Featured</a></li>
          <li aria-label="Best selling"><a href="#" data-sort="best-selling" title="Best selling" aria-label="Best selling">Best selling</a></li>
          <li aria-label="Alphabetically, A-Z"><a href="#" data-sort="title-ascending" title="Alphabetically, A-Z" aria-label="Alphabetically, A-Z">Alphabetically, A-Z</a></li>
          <li aria-label="Alphabetically, Z-A"><a href="#" data-sort="title-descending" title="Alphabetically, Z-A" aria-label="Alphabetically, Z-A">Alphabetically, Z-A</a></li>
          <li aria-label="Price, low to high"><a href="#" data-sort="price-ascending" title="Price, low to high" aria-label="Price, low to high">Price, low to high</a></li>
          <li aria-label="Price, high to low"><a href="#" data-sort="price-descending" title="Price, high to low" aria-label="Price, high to low">Price, high to low</a></li>
          <li aria-label="Date, old to new"><a href="#" data-sort="created-ascending" title="Date, old to new" aria-label="Date, old to new">Date, old to new</a></li>
          <li aria-label="Date, new to old"><a href="#" data-sort="created-descending" title="Date, new to old" aria-label="Date, new to old">Date, new to old</a></li>
        </ul>`;

      const button = wrapper.querySelector('.boost-pfs-filter-top-sorting-wrapper');

      if (button) {
        const itemsWrapper = document.querySelector('.boost-pfs-filter-filter-dropdown');
        const items = document.querySelectorAll('.boost-pfs-filter-filter-dropdown li a');
        
        button.addEventListener('click', () => {

          if (wrapper.classList.contains('boost-pfs-filter-sort-active')) {
            wrapper.classList.remove('boost-pfs-filter-sort-active');
            itemsWrapper.style.display = 'none';
            
          } else {
            wrapper.classList.add('boost-pfs-filter-sort-active');
            itemsWrapper.style.display = 'block';
          }
    
          if (items.length) {
    
            for (var i = 0; i < items.length; i++) {
              const item = items[i];
    
              item.addEventListener('click', () => {
                const itemLink = item.children;
                const itemValue = item.getAttribute('data-sort');
                
                var newItemLink = obj.data.query;
    
                if (newItemLink.includes('?')) {
                  newItemLink += '&'
                }
    
                newItemLink += `sort=${itemValue}`;
                window.location.href = newItemLink;
              });
            }
          }
        });
      }
    }
    /*** /SORTING ***/

    /*** PRODUCTS ***/
    renderProducts() {
      const obj = this;

      const wrapper = document.querySelector('.boost-pfs-filter-products');
      wrapper.innerHTML = '';
      
      if (obj.data.products.items.length) {

        for (var i = 0; i < obj.data.products.items.length; i++) {
          const item = obj.data.products.items[i];
          const product = document.createElement('div');
          product.classList.add('boost-pfs-filter-product-item');
          product.classList.add('boost-pfs-filter-product-item-grid');
          product.classList.add('boost-pfs-filter-grid-width-3');
          product.classList.add('boost-pfs-filter-grid-width-mb-2');
          
          product.setAttribute('data-title', item.title);
          product.setAttribute('data-id', item.id);
          product.setAttribute('data-page', 1);
  
          const productImageRatio = item.images_info[0].width / item.images_info[0].height;
          const productImagePaddingBottom = item.images_info[0].height / item.images_info[0].width * 100;
  
          const productUrl = obj.data.productUrl + item.handle;

          let productCollectionHandle;
          let productCollection;
          
          productCollection = item.collections[0];
          
          for (var i2 = 0; i2 < item.tags.length; i2++) {
            const tag = item.tags[i2];

            if (/^collection\-handle\:.+$/.test(tag)) {
              productCollectionHandle = tag.replace(/^collection\-handle\:(.+)$/, '$1');
              
              for (var i3 = 0; i3 < item.collections.length; i3++) {
                const collection = item.collections[i3];

                if (collection.handle == productCollectionHandle) {
                  productCollection = collection;
                }
              }
            }
          }

          product.innerHTML = 
            `<div class="boost-pfs-filter-product-item-inner">
  
              <div class="boost-pfs-filter-product-item-image">
                <a
                  href="${productUrl}"
                  class="boost-pfs-filter-product-item-image-link boost-pfs-filter-crop-image-position-center"
                  style="padding-bottom: ${productImagePaddingBottom}%;"
                  target="_blank">
                    <img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"
                         src="${item.images_info[0].src}"
                         alt="${item.title}"
                         data-style="filter: blur(50px);">
                </a>
                <div class="wishlist-container">
                  <button
                    data-with-epi="true"
                    class="swym-button swym-add-to-wishlist-view-product product_${item.id} swym-icon swym-heart swym-loaded"
                    data-swaction="addToWishlist"
                    data-product-id="${item.id}"
                    data-variant-id="${item.variants[0].id}"
                    data-product-url="https://bazaa.com.au${productUrl}"
                    aria-label="Add to Wishlist"
                    style="
                      position: absolute !important;
                      top: 5px;
                      right: 7px;
                      z-index: 10;
                      width: 32px;
                      height: 32px !important;
                    ">
                    <span class="swym-tooltip swym-inject swym-tooltip-clickable">
                      <span class="swym-tooltip-text">Add to wishlist</span>
                    </span>
                  </button>
                </div>
              </div>
              
              <div class="boost-pfs-filter-product-bottom">
                <div class="boost-pfs-filter-product-bottom-inner">
  
                  <a
                    href="${productUrl}"
                    class="boost-pfs-filter-product-item-title"
                    target="_blank">
                    <span class="has-collection-title">
                      <span class="boost-collection-title">
                        ${productCollection.title}
                      </span>
                      <span class="boost-product-title">
                        <span class="boost-product-title">
                          ${item.title}
                        </span>
                      </span>
                    </span>
                  </a>
                  <p class="boost-pfs-filter-product-item-price">
                    <span class="boost-pfs-filter-product-item-regular-price">
                      ${item.price_min} ${Shopify.currency.active}
                    </span>
                  </p>
                </div>
              </div>
              
            </div>`;
  
          wrapper.insertAdjacentElement(
            'beforeend',
            product
          );
        }
      }
    }

    renderMobileProducts() {
      const obj = this;
    }
    /*** /PRODUCTS ***/
    
    /*** FILTERS ***/
    renderFilters() {
      const obj = this;

      const wrapper = document.getElementById('boost-pfs-filter-tree2');
      wrapper.innerHTML = 
        `<div class="boost-pfs-filter-tree-content" aria-live="polite" role="navigation" aria-label="Product filter">
          <div class="boost-pfs-filter-refine-by-wrapper">
            <div class="boost-pfs-filter-refine-by">
              <div class="boost-pfs-filter-option-title">
                <div class="boost-pfs-filter-option-title-heading" role="heading" aria-level="2">
                  <span>Refine By</span>
                </div>
                <a href="${obj.data.clearUrl}" aria-label="Clear all filters" class="boost-pfs-filter-button boost-pfs-filter-clear-all">Clear All</a>
              </div>
              <div class="boost-pfs-filter-refine-by-items"></div>
            </div>
          </div>
          <div class="boost-pfs-filter-options-wrapper"></div>
          <div class="boost-pfs-filter-mobile-footer">
            <button class="boost-pfs-filter-show-result" type="button">Show result<span class="boost-pfs-filter-number-result boost-pfs-filter-number-result-has-data"> (5)</span></button>
			<button class="boost-pfs-filter-button boost-pfs-filter-apply-all-button">Apply All</button>
          </div>
        </div>`;
      
      /* Active */
      const activeFiltersWrapper = wrapper.querySelector('.boost-pfs-filter-refine-by-wrapper');
      activeFiltersWrapper.innerHTML = 
        `<div class="boost-pfs-filter-refine-by">
          <div class="boost-pfs-filter-option-title">
            <div class="boost-pfs-filter-option-title-heading" role="heading" aria-level="2">
              <span>Refine By</span>
            </div>
            <a href="${obj.data.clearUrl}" aria-label="Clear all filters" class="boost-pfs-filter-button boost-pfs-filter-clear-all">Clear All</a>
          </div>
          <div class="boost-pfs-filter-refine-by-items"></div>
        </div>`;
      
      const activeFilterOptions = obj.data.query.split('?')[1].split('&');
      let activeFilterOptionIds = [];
  
      for (var i = 0; i < activeFilterOptions.length; i++) {
        const activeFilterOption = activeFilterOptions[i];
        const activeFilterOptionParts = activeFilterOption.split('=');
        
        activeFilterOptionIds.push(activeFilterOptionParts[0]);
      }
  
      if (activeFilterOptionIds) {
        activeFiltersWrapper.removeAttribute('style');
      }
      
      const activeFilters = wrapper.querySelector('.boost-pfs-filter-refine-by-items');

      if (obj.data.filters.items.length) {
        const filters = wrapper.querySelector('.boost-pfs-filter-options-wrapper');

        for (var i = 0; i < obj.data.filters.items.length; i++) {
          const item = obj.data.filters.items[i];
          obj.renderFiltersItem(item, filters, activeFilters, activeFilterOptions);
        }
      }
      /* /Active */
      
      obj.renderFiltersLabels();
      obj.renderFiltersCloseButtons();
      obj.renderFiltersActiveItems();
    }
    
    renderFiltersItem(item, filters, activeFilters, activeFilterOptions) {
      const obj = this;
      
      if (typeof item.values !== 'undefined' &&
          item.values.length) {
        const filter = document.createElement('div');
        filter.classList.add('boost-pfs-filter-option');
        
        if (item.displayType) {
          filter.classList.add(`boost-pfs-filter-option-${item.displayType}`);
        }
        
        filter.classList.add('boost-pfs-filter-option-category');

        if (item.showMoreType) {
          filter.classList.add('boost-pfs-filter-has-scrollbar');
        }
        
        filter.classList.add('boost-pfs-filter-option-column-1');
        filter.innerHTML = 
          `<div class="boost-pfs-filter-option-title">
            <button aria-controls="boost-pfs-filter-tree-pf-pt-category" aria-label="Filter by ${item.label}" tabindex="0" class="boost-pfs-filter-button boost-pfs-filter-option-title-heading" aria-expanded="false">
              <span class="boost-pfs-filter-option-title-text">
                ${item.label}
                <span class="boost-pfs-filter-option-title-count"></span>
              </span>
            </button>
            <button aria-label="Clear filter by ${item.label}" class="boost-pfs-filter-button boost-pfs-filter-clear" style="display: none;">Clear</button>
          </div>
          
          <div class="boost-pfs-filter-option-content">
            <div class="boost-pfs-filter-option-content-inner">
              <ul class="boost-pfs-filter-option-item-list boost-pfs-filter-option-item-list-${item.displayType}" data-filter-option-id="${item.filterOptionId}"></ul>
            </div>
            <button class="boost-pfs-filter-button boost-pfs-filter-apply-button">Apply</button>
          </div>`;
        
        const filterValues = filter.querySelector('.boost-pfs-filter-option-item-list');

        if (item.displayType == 'swatch') {
          filterValues.classList.add('boost-pfs-filter-option-item-list-swatch');
        
        } else if (item.displayType == 'list' && item.selectType == 'multiple') {
          filterValues.classList.add('boost-pfs-filter-option-item-list-multiple-list');
        }
    
        if (item.swatchStyle) {
          filterValues.classList.add(item.swatchStyle);
        }

        for (var i2 = 0; i2 < item.values.length; i2++) {
          const itemValue = item.values[i2];

          const filterValue = document.createElement('li');
          filterValue.classList.add('boost-pfs-filter-option-item');
          filterValue.classList.add('boost-pfs-filter-option-label');
    
          let filterValueTitle;
          var filterValueSwatch;
    
          if (itemValue.label) {
            filterValueTitle = itemValue.label;
            
          } else if (itemValue.key) {
            
            if (item.prefix == 'colour\\:') {
              filterValueTitle = itemValue.key.split(':')[1];
              filterValueTitle = window.themeObj.tools.toCapitalize(filterValueTitle);
              
            } else if (item.prefix == 'print\\:') {
              filterValueTitle = itemValue.key.split(':')[1];
              filterValueTitle = window.themeObj.tools.toCapitalize(filterValueTitle);
            
            } else {
              filterValueTitle = itemValue.key;
            }
          }
        
          if (item.filterType == 'collection') {
            filterValue.innerHTML =
              `<a href="/collections/${itemValue.handle}" class="boost-pfs-filter-button">
                <span class="boost-pfs-check-box" role="checkbox" tabindex="0" aria-labelledby="${filterValueTitle}"></span>
                <span class="boost-pfs-filter-option-value">${filterValueTitle}</span>
                <span class="boost-pfs-filter-option-amount"></span>
              </a>`;
    
          } else {
            let finalFilterValueTitle;

            if (/^.+\:(.+)$/.test(filterValueTitle)) {
              finalFilterValueTitle = filterValueTitle.replace(/^.+\:(.+)$/, '$1');
              
            } else {
              finalFilterValueTitle = filterValueTitle;
            }
            
            filterValue.innerHTML =
              `<button role="checkbox" class="boost-pfs-filter-button">
                <span class="boost-pfs-check-box" role="checkbox" tabindex="0" aria-labelledby="${filterValueTitle}"></span>
                <span class="boost-pfs-filter-option-value">${finalFilterValueTitle}</span>
                <span class="boost-pfs-filter-option-amount">(${item.values.length})</span>
              </button>`;

            console.log('item', item, 'item.prefix', item.prefix);
            
            var filterValueSwatch = boostPFSAppConfig.swatch_settings[itemValue.key.toLowerCase()];
    
            if (filterValueSwatch) {
              
              if (filterValueSwatch.type == 'image') {
                filterValue.insertAdjacentHTML(
                  'afterbegin',
                  `<span class="boost-pfs-filter-option-swatch-image" style="background-color: #000; background-image: url(${filterValueSwatch.imageUrl});"></span>`
                );
                
              } else if (filterValueSwatch.type == 'one_color') {
                filterValue.insertAdjacentHTML(
                  'afterbegin',
                  `<span class="boost-pfs-filter-option-swatch-image" style="background-color: ${filterValueSwatch.colorCodes[0]}; background-image: none;"></span>`
                );
              }
              
            } else if (item.prefix == 'print\\:') {
              filterValue.insertAdjacentHTML(
                'afterbegin',
                `<span class="boost-pfs-filter-option-swatch-image" style="background-color: #000; background-image: none;"></span>`
              );
              
            } else {
              filterValue.insertAdjacentHTML(
                'afterbegin',
                `<span class="boost-pfs-filter-option-swatch-image" style="background-color: ${itemValue.key.toLowerCase()}; background-image: url(//bazaa.com.au/cdn/shop/files/colour-${itemValue.key.toLowerCase()}.png?v=1111111);"></span>`
              );
            }
          }
        
          if ((item.prefix == 'print\\:' ||item.prefix == 'colour\\:')) {
            var filterValueEncoded = encodeURIComponent(itemValue.key).replace('%20', '+');
          
          } else {
            var filterValueEncoded = encodeURIComponent(filterValueTitle).replace('%20', '+');
          }
          
          const itemValueUri = `${item.filterOptionId}=${filterValueEncoded}`;
          filterValue.setAttribute('data-option-uri', itemValueUri);

          if (activeFilterOptions.includes(itemValueUri)) {
            filterValue.classList.add('selected');
            
            filter.querySelector('.boost-pfs-filter-clear').removeAttribute('style');
    
            /* Active filter */
            const activeFilter = document.createElement('div');
            activeFilter.classList.add('refine-by-item');
            activeFilter.classList.add('boost-pfs-filter-option-label');
            activeFilter.setAttribute('data-option-uri', itemValueUri);
            
            activeFilter.innerHTML =
              `<button aria-label="Clear filter by ${item.label} ${filterValueTitle}" class="boost-pfs-filter-button boost-pfs-filter-clear">
                <span class="refine-by-type">
                  <span class="refine-by-option">${item.label}: </span><span class="refine-by-value">${filterValueTitle}</span>
                </span>
              </button>`;
    
            activeFilters.insertAdjacentElement(
              'beforeend',
              activeFilter
            );
            /* /Active filter */
          }
        
          filterValues.insertAdjacentElement(
            'beforeend',
            filterValue
          );
        }

        filters.insertAdjacentElement(
          'beforeend',
          filter
        );
      }
    }
    
    renderMobileFilters() {
      const obj = this;
   
      const wrapper = document.getElementById('boost-pfs-filter-tree');
      wrapper.classList.add('boost-pfs-filter-tree-mobile-style2');
      wrapper.classList.add('boost-pfs-filter-tree-mobile-sticky');
      wrapper.innerHTML = 
        `<div class="boost-pfs-filter-tree-content" aria-live="polite" role="navigation" aria-label="Product filter">
        
          <div class="boost-pfs-filter-mobile-toolbar">
            <div class="boost-pfs-filter-mobile-toolbar-top">
              <a href="javascript:void(0);" class="boost-pfs-filter-close">
                <span>Close</span>
              </a>
            </div>
            <div class="boost-pfs-filter-mobile-toolbar-items">
              <div class="boost-pfs-filter-mobile-toolbar-left">
                <span class="boost-pfs-filter-back-btn" aria-label="Back" style="display: none;"></span>
              </div>
              <div class="boost-pfs-filter-mobile-toolbar-middle" data-text="Refine By">Refine By</div>
              <div class="boost-pfs-filter-mobile-toolbar-right">
                <button aria-label="Clear all filters" class="boost-pfs-filter-button boost-pfs-filter-clear-all">Clear All</button>
              </div>
            </div>
          </div>
          
          <div class="boost-pfs-filter-refine-by-wrapper"></div>

          <div
            class="boost-pfs-filter-options-wrapper"
            style="top: 43px;"></div>

          <div class="boost-pfs-filter-mobile-footer">
            <button class="boost-pfs-filter-show-result" type="button">Show result <span></span></button>
            <button class="boost-pfs-filter-button boost-pfs-filter-apply-all-button">Apply All</button>
          </div>
          
        </div>`;

      const sidebarHeaderButton = wrapper.querySelector('.boost-pfs-filter-back-btn');
      sidebarHeaderButton.addEventListener('click', () => {
        sidebarHeaderButton.style.display = 'none';

        const sidebarHeaderTitle = wrapper.querySelector('.boost-pfs-filter-mobile-toolbar-middle');
        sidebarHeaderTitle.innerHTML = sidebarHeaderTitle.getAttribute('data-text');

        const sidebarHeaderClearAll = wrapper.querySelector('.boost-pfs-filter-mobile-toolbar-right .boost-pfs-filter-clear-all');
        sidebarHeaderClearAll.style.display = 'none';
        
        const activeFilters = wrapper.querySelectorAll('.boost-pfs-filter-option');

        for (var i = 0; i < activeFilters.length; i++) {
          const activeFilter = activeFilters[i];
          const activeFilterTitle = activeFilter.querySelector('.boost-pfs-filter-option-title');
          activeFilterTitle.style.display = 'block';
          
          const activeFilterContent = activeFilter.querySelector('.boost-pfs-filter-option-content');
          activeFilterContent.setAttribute('style', 'display: none !important');
        }
        
      });
      
      /* Active */
      const activeFiltersWrapper = wrapper.querySelector('.boost-pfs-filter-refine-by-wrapper');
      activeFiltersWrapper.innerHTML = 
        `<div class="boost-pfs-filter-refine-by">
          <div class="boost-pfs-filter-option-title">
            <div class="boost-pfs-filter-option-title-heading" role="heading" aria-level="2">
              <span>Refine By</span>
            </div>
            <a href="${obj.data.clearUrl}" aria-label="Clear all filters" class="boost-pfs-filter-button boost-pfs-filter-clear-all">Clear All</a>
          </div>
          <div class="boost-pfs-filter-refine-by-items"></div>
        </div>`;
      
      const activeFilterOptions = obj.data.query.split('?')[1].split('&');
      let activeFilterOptionIds = [];
  
      for (var i = 0; i < activeFilterOptions.length; i++) {
        const activeFilterOption = activeFilterOptions[i];
        const activeFilterOptionParts = activeFilterOption.split('=');
        
        activeFilterOptionIds.push(activeFilterOptionParts[0]);
      }
  
      if (activeFilterOptionIds) {
        activeFiltersWrapper.removeAttribute('style');
      }
      
      const activeFilters = wrapper.querySelector('.boost-pfs-filter-refine-by-items');

      if (obj.data.filters.items.length) {
        const filters = wrapper.querySelector('.boost-pfs-filter-options-wrapper');

        for (var i = 0; i < obj.data.filters.items.length; i++) {
          const item = obj.data.filters.items[i];
          obj.renderMobileFiltersItem(item, filters, activeFilters, activeFilterOptions);
        }
      }
      /* /Active */
      
      const clearAllButton = wrapper.querySelector('.boost-pfs-filter-clear-all');

      clearAllButton.addEventListener('click', () => {
        window.location.href = obj.data.clearUrl;
      });
      
      const filterButton = document.querySelector('.boost-pfs-filter-tree-mobile-button');
      filterButton.innerHTML = 
        `<button type="button" aria-label="Refine By">
          <span class="boost-pfs-filter-tree-mobile-button-label">Refine By</span>
        </button>`;
  
      filterButton.addEventListener('click', () => {
        wrapper.classList.add('boost-pfs-filter-tree-mobile-open');
        document.body.classList.add('boost-pfs-filter-tree-open-body');
      });
      
      const closeButton = document.querySelector('.boost-pfs-filter-close');
  
      closeButton.addEventListener('click', () => {
        wrapper.classList.remove('boost-pfs-filter-tree-mobile-open');
        document.body.classList.remove('boost-pfs-filter-tree-open-body');
      });
      
      const items = document.querySelectorAll('.boost-pfs-filter-option-item-list li');
  
      if (items) {
  
        for (var i = 0; i < items.length; i++) {
          const item = items[i];
  
          item.addEventListener('click', function() {
            const itemUri = item.getAttribute('data-option-uri');
  
            let newQuery = obj.data.query;
  
            if (item.classList.contains('selected')) {
              item.classList.remove('selected');
  
              if (obj.data.query.includes(`?${itemUri}`)) {
                newQuery = newQuery.replace(`?${itemUri}`, '');
              
              } else if (obj.data.query.includes(`&${itemUri}`)) {
                newQuery = newQuery.replace(`&${itemUri}`, '');
              }
              
            } else {
              item.classList.add('selected');
  
              newQuery += (obj.data.query.includes('?') ? '&' : '?') + itemUri;
            }

            if (/\/search\&/.test(newQuery)) {
              newQuery = newQuery.replace(/\/search\&/, '/search?');
            }
  
            obj.showLoader();
            
            window.location.href = newQuery;
          });
        }
      }
      
      const showMoreButton = document.querySelector('.boost-pfs-filter-show-result');
  
      if (showMoreButton) {
        
        showMoreButton.addEventListener('click', function() {
          wrapper.classList.remove('boost-pfs-filter-tree-mobile-open');
          document.body.classList.remove('boost-pfs-filter-tree-open-body');
        });
      }
    }
    
    renderMobileFiltersItem(item, filters, activeFilters, activeFilterOptions) {
      const obj = this;
      
      if (typeof item.values !== 'undefined' &&
          item.values.length) {
        const filter = document.createElement('div');
        filter.classList.add('boost-pfs-filter-option');

        if (item.displayType) {
          filter.classList.add(`boost-pfs-filter-option-${item.displayType}`);
        }
        
        filter.classList.add('boost-pfs-filter-option-category');

        if (item.showMoreType) {
          filter.classList.add('boost-pfs-filter-has-scrollbar');
        }
        
        filter.classList.add('boost-pfs-filter-option-column-1');
        filter.innerHTML = 
          `<div class="boost-pfs-filter-option-title">
            <button aria-controls="boost-pfs-filter-tree-pf-pt-category" aria-label="Filter by ${item.label}" tabindex="0" class="boost-pfs-filter-button boost-pfs-filter-option-title-heading" aria-expanded="false">
              <span class="boost-pfs-filter-option-title-text">
                ${item.label}
                <span class="boost-pfs-filter-option-title-count"></span>
              </span>
            </button>
            <p class="boost-pfs-filter-selected-items-mobile"></p>
            <button aria-label="Clear filter by ${item.label}" class="boost-pfs-filter-button boost-pfs-filter-clear" style="display: none;">Clear</button>
          </div>
          
          <div class="boost-pfs-filter-option-content" style="display: none;">
            <div class="boost-pfs-filter-option-content-inner">
              <ul class="boost-pfs-filter-option-item-list boost-pfs-filter-option-item-list-${item.displayType}" data-filter-option-id="${item.filterOptionId}"></ul>
            </div>
            <button class="boost-pfs-filter-button boost-pfs-filter-apply-button">Apply</button>
          </div>`;

        const filterTitle = filter.querySelector('.boost-pfs-filter-option-title');

        filterTitle.addEventListener('click', () => {
          const activeFilters = filterTitle.parentNode.parentNode.querySelectorAll('.boost-pfs-filter-option');

          for (var i = 0; i < activeFilters.length; i++) {
            const activeFilter = activeFilters[i];
            const activeFilterTitle = activeFilter.querySelector('.boost-pfs-filter-option-title');
            activeFilterTitle.style.display = 'none';
            
            const activeFilterContent = activeFilter.querySelector('.boost-pfs-filter-option-content');
            activeFilterContent.setAttribute('style', 'display: none !important');
          }
          
          filterTitle.style.display = 'none';
          const filterTitleText = filterTitle.querySelector('.boost-pfs-filter-option-title-text').innerHTML.trim();
          
          const filterContent = filter.querySelector('.boost-pfs-filter-option-content');
          filterContent.classList.add('boost-pfs-filter-option-content-open');
          filterContent.style.display = 'flex';

          const sidebarHeaderTitle = document.querySelector('.boost-pfs-filter-mobile-toolbar-middle');
          sidebarHeaderTitle.innerHTML = filterTitleText;

          const sidebarHeaderButton = document.querySelector('.boost-pfs-filter-mobile-toolbar-left .boost-pfs-filter-back-btn');
          sidebarHeaderButton.style.display = 'inline';

          const sidebarHeaderClearAll = document.querySelector('.boost-pfs-filter-mobile-toolbar-right .boost-pfs-filter-clear-all');
          sidebarHeaderClearAll.style.display = 'none';
        });
        
        const filterValues = filter.querySelector('.boost-pfs-filter-option-item-list');

        if (item.displayType == 'swatch') {
          filterValues.classList.add('boost-pfs-filter-option-item-list-swatch');
        
        } else if (item.displayType == 'list' && item.selectType == 'multiple') {
          filterValues.classList.add('boost-pfs-filter-option-item-list-multiple-list');
        }
    
        if (item.swatchStyle) {
          filterValues.classList.add(item.swatchStyle);
        }

        var itemActiveValues = [];
        
        for (var i2 = 0; i2 < item.values.length; i2++) {
          const itemValue = item.values[i2];

          const filterValue = document.createElement('li');
          filterValue.classList.add('boost-pfs-filter-option-item');
          filterValue.classList.add('boost-pfs-filter-option-label');
    
          let filterValueTitle;
          var filterValueSwatch;
    
          if (itemValue.label) {
            filterValueTitle = itemValue.label;
            
          } else if (itemValue.key) {
            
            if (item.prefix == 'colour\\:') {
              filterValueTitle = itemValue.key.split(':')[1];
              filterValueTitle = window.themeObj.tools.toCapitalize(filterValueTitle);
              
            } else if (item.prefix == 'print\\:') {
              filterValueTitle = itemValue.key.split(':')[1];
              filterValueTitle = window.themeObj.tools.toCapitalize(filterValueTitle);
            
            } else {
              filterValueTitle = itemValue.key;
            }
          }
        
          if (item.filterType == 'collection') {
            filterValue.innerHTML =
              `<a href="/collections/${itemValue.handle}" class="boost-pfs-filter-button">
                <span class="boost-pfs-check-box" role="checkbox" tabindex="0" aria-labelledby="${filterValueTitle}"></span>
                <span class="boost-pfs-filter-option-value">${filterValueTitle}</span>
                <span class="boost-pfs-filter-option-amount"></span>
              </a>`;
    
          } else {
            let finalFilterValueTitle;

            if (/^.+\:(.+)$/.test(filterValueTitle)) {
              finalFilterValueTitle = filterValueTitle.replace(/^.+\:(.+)$/, '$1');
              
            } else {
              finalFilterValueTitle = filterValueTitle;
            }
            
            filterValue.innerHTML =
              `<button role="checkbox" class="boost-pfs-filter-button">
                <span class="boost-pfs-check-box" role="checkbox" tabindex="0" aria-labelledby="${filterValueTitle}"></span>
                <span class="boost-pfs-filter-option-value">${finalFilterValueTitle}</span>
                <span class="boost-pfs-filter-option-amount">(${item.values.length})</span>
              </button>`;
            
            var filterValueSwatch = boostPFSAppConfig.swatch_settings[itemValue.key.toLowerCase()];
    
            if (filterValueSwatch) {
              
              if (filterValueSwatch.type == 'image') {
                filterValue.insertAdjacentHTML(
                  'afterbegin',
                  `<span class="boost-pfs-filter-option-swatch-image" style="background-color: #000; background-image: url(${filterValueSwatch.imageUrl});"></span>`
                );
                
              } else if (filterValueSwatch.type == 'one_color') {
                filterValue.insertAdjacentHTML(
                  'afterbegin',
                  `<span class="boost-pfs-filter-option-swatch-image" style="background-color: ${filterValueSwatch.colorCodes[0]}; background-image: none;"></span>`
                );
              }
              
            } else if (item.prefix == 'print\\:') {
              filterValue.insertAdjacentHTML(
                'afterbegin',
                `<span class="boost-pfs-filter-option-swatch-image" style="background-color: #000; background-image: none;"></span>`
              );
              
            } else {
              filterValue.insertAdjacentHTML(
                'afterbegin',
                `<span class="boost-pfs-filter-option-swatch-image" style="background-color: ${itemValue.key.toLowerCase()}; background-image: url(//bazaa.com.au/cdn/shop/files/colour-${itemValue.key.toLowerCase()}.png?v=1111111);"></span>`
              );
            }
          }
        
          if ((item.prefix == 'print\\:' ||item.prefix == 'colour\\:')) {
            var filterValueEncoded = encodeURIComponent(itemValue.key).replace('%20', '+');
          
          } else {
            var filterValueEncoded = encodeURIComponent(filterValueTitle).replace('%20', '+');
          }
          
          const itemValueUri = `${item.filterOptionId}=${filterValueEncoded}`;
          filterValue.setAttribute('data-option-uri', itemValueUri);

          if (activeFilterOptions.includes(itemValueUri)) {
            filterValue.classList.add('selected');
            itemActiveValues.push(filterValueTitle);
            
            filter.querySelector('.boost-pfs-filter-clear').removeAttribute('style');
          }
        
          filterValues.insertAdjacentElement(
            'beforeend',
            filterValue
          );
        }

        if (itemActiveValues) {
          const filterActiveValues = filter.querySelector('.boost-pfs-filter-selected-items-mobile');
          filterActiveValues.innerHTML = itemActiveValues.join(', ');
        }

        filters.insertAdjacentElement(
          'beforeend',
          filter
        );
      }
    }
    
    renderFiltersLabels() {
      const obj = this;
      
      const items = document.querySelectorAll('.boost-pfs-filter-tree-v .boost-pfs-filter-option .boost-pfs-filter-option-title .boost-pfs-filter-option-title-heading');
      
      if (items.length) {
  
        for (var i = 0; i < items.length; i++) {
          const item = items[i];
          
          item.addEventListener('click', () => {
            const filter = item.parentNode.parentNode;
            const filterContent = filter.querySelector('.boost-pfs-filter-option-content');
  
            if (filter.classList.contains('boost-pfs-filter-option-collapsed')) {
              filter.classList.remove('boost-pfs-filter-option-collapsed');
              filterContent.classList.remove('toggled');
            
            } else {
              filter.classList.add('boost-pfs-filter-option-collapsed');
              filterContent.classList.add('toggled');
            }
          });
        }
      }
    }

    renderFiltersCloseButtons() {
      const obj = this;
      
      const items = document.querySelectorAll('.boost-pfs-filter-option .boost-pfs-filter-option-title .boost-pfs-filter-clear');
      
      if (items.length) {
  
        for (var i = 0; i < items.length; i++) {
          const item = items[i];
          
          item.addEventListener('click', function() {
            const filterOptions = item.parentNode.parentNode.querySelectorAll('.boost-pfs-filter-option-item-list li.selected');
            
            let newQuery = obj.data.query;
  
            if (filterOptions.length) {
  
              for (var i2 = 0; i2 < filterOptions.length; i2++) {
                const filterOption = filterOptions[i2];
                const filterOptionUri = filterOption.getAttribute('data-option-uri');
  
                if (obj.data.query.includes(`?${filterOptionUri}`)) {
                  newQuery = newQuery.replace(`?${filterOptionUri}`, '');
                
                } else if (obj.data.query.includes(`&${filterOptionUri}`)) {
                  newQuery = newQuery.replace(`&${filterOptionUri}`, '');
                }
              }
            }
  
            if (/\/search\&/.test(newQuery)) {
              newQuery = newQuery.replace(/\/search\&/, '/search?');
            }
  
            obj.showLoader();
  
            window.location.href = newQuery;
          });
        }
      }
    }

    renderFiltersActiveItems() {
      const obj = this;
      
      const items = document.querySelectorAll('.boost-pfs-filter-refine-by .boost-pfs-filter-refine-by-items .refine-by-item');
  
      if (items) {
        
        for (var i = 0; i < items.length; i++) {
          const item = items[i];
  
          item.addEventListener('click', function() {
            const itemOptionUri = item.getAttribute('data-option-uri');
            
            let newQuery = obj.data.query;
            
            if (obj.data.query.includes(`?${itemOptionUri}`)) {
              newQuery = newQuery.replace(`?${itemOptionUri}`, '');
            
            } else if (obj.data.query.includes(`&${itemOptionUri}`)) {
              newQuery = newQuery.replace(`&${itemOptionUri}`, '');
            }
  
            if (/\/search\&/.test(newQuery)) {
              newQuery = newQuery.replace(/\/search\&/, '/search?');
            }
            
            obj.showLoader();
  
            window.location.href = newQuery;
          });
        }
      }
    }
    /*** /FILTERS ***/

    showMoreButton() {
      const obj = this;

      if (obj.data.products.items.length >= obj.data.productsLimit) {
        const showMoreWrapper = document.querySelector('.boost-pfs-filter-btn-load-previous-page-wrapper');
        showMoreWrapper.removeAttribute('style');
      }
    }

    showLoader() {
      return;
      const loader = document.querySelector('.boost-pfs-filter-loading');
      loader.style.display = 'block';
    }
  }
};

window.themeObj.init();